import React from "react";

const Topbar = () => {
  return (
    <div className="flex justify-between items-center my-8">
      <div className="flex gap-5 items-center w-full">
        <img src="/assets/user.png" alt="user" className="w-12" />
        <div>
          <div className="font-bold text-16">Sarah O. Williams</div>
          <div>
            <div className="text-13 text-[#A4A4A4]">Seasoned Tutor</div>
          </div>
        </div>
        <div className="w-10 h-10 bg-gray-300 rounded-full"></div>
      </div>
    </div>
  );
};

export default Topbar;
